import request from '@/util/request';

export const getList = (params, options) =>
  request.get('/api/v4ward/charger/page', Object.assign({}, options, { params }));

export const getDetail = (id) => {
  return request({
    url: '/api/v4ward/charger/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const remove = (ids) => {
  return request({
    url: '/api/v4ward/charger/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const add = (row) => {
  return request({
    url: '/api/v4ward/charger/submit',
    method: 'post',
    data: row,
  });
};

export const update = (row) => {
  return request({
    url: '/api/v4ward/charger/submit',
    method: 'post',
    data: row,
  });
};
